import * as React from "react";
import { Slot } from "@radix-ui/react-slot";

const buttonBaseStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'nowrap',
  borderRadius: '0.5rem',
  fontSize: '0.875rem',
  fontWeight: 500,
  transition: 'all 0.2s ease',
  cursor: 'pointer',
  border: 'none',
  outline: 'none',
};

const variantStyles = {
  default: {
    backgroundColor: '#0f172a',
    color: 'white',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  },
  destructive: {
    backgroundColor: '#ef4444',
    color: 'white',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  },
  outline: {
    backgroundColor: 'white',
    color: '#0f172a',
    border: '1px solid #e2e8f0',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  },
  secondary: {
    backgroundColor: '#f1f5f9',
    color: '#0f172a',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  },
  ghost: {
    backgroundColor: 'transparent',
    color: '#0f172a',
  },
  link: {
    backgroundColor: 'transparent',
    color: '#0f172a',
    textDecoration: 'underline',
    textUnderlineOffset: '4px',
  },
  success: {
    backgroundColor: '#10b981',
    color: 'white',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  },
  warning: {
    backgroundColor: '#f59e0b',
    color: 'white',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  },
};

const sizeStyles = {
  default: {
    height: '2.25rem',
    padding: '0.5rem 1rem',
  },
  sm: {
    height: '2rem',
    padding: '0.25rem 0.75rem',
    fontSize: '0.75rem',
    borderRadius: '0.375rem',
  },
  lg: {
    height: '2.5rem',
    padding: '0.5rem 2rem',
  },
  icon: {
    height: '2.25rem',
    width: '2.25rem',
    padding: 0,
  },
};

const Button = React.forwardRef(
  ({ className, variant = 'default', size = 'default', asChild = false, style, disabled, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    
    const combinedStyle = {
      ...buttonBaseStyle,
      ...(variantStyles[variant] || variantStyles.default),
      ...(sizeStyles[size] || sizeStyles.default),
      ...(disabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}),
      ...style,
    };
    
    return (
      <Comp
        style={combinedStyle}
        ref={ref}
        disabled={disabled}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button };
